export enum EConductivite {
    C1413 = 1,
    C84 = 2,
    C0
}